<div class="grid-x">
  <div class="cell large-12 medium-12 small-12 bold">
    <div class="section-header" [ngClass]="{ 'active' : step == activeStep }" (click)="toggleOpen()">
      <span class="margin-right">Reviewer Section</span>
      <button class="icon-button">
        @if (isOpen == false) {
          <svg-icon icon="icon-caret-right"></svg-icon>
        }
        @if (isOpen == true) {
          <svg-icon icon="icon-caret-down"></svg-icon>
        }
      </button>
    </div>
  </div>
</div>
<div class="grid-x margin-top" [formGroup]="form" [ngClass]="{ 'hideSection': isOpen == false }">
  <div class="cell large-3 medium-3 small-6 bold text-align-right padding-right">
    Source of Location:
    @if (fieldHasNotes('review|sourceOfLocation') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'review|sourceOfLocation'" [notes]="getFilteredNotes('review|sourceOfLocation')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-3 medium-3 small-6">
    <select formControlName="sourceOfLocation" id="loc">
      @for (s of locationSources | async; track s) {
        <option [ngValue]="s.Code">{{s.Definition}}</option>
      }
    </select>
  </div>
  <div class="cell large-6 medium-6 small-12">&nbsp;</div>
  <div class="cell large-3 medium-3 small-6 bold text-align-right padding-right">
    As Drilled Plat Preliminary Date:
    @if (fieldHasNotes('review|asDrilledPlatPreliminaryDate') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'review|asDrilledPlatPreliminaryDate'" [notes]="getFilteredNotes('review|asDrilledPlatPreliminaryDate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6 text-align-left">
    <common-date-picker [id]="'preliminaryDate'" [initialDate]="preliminaryDate" (dateUpdated)="onDateUpdated($event, 'asDrilledPlatPreliminaryDate')" [disabled]="form?.get('asDrilledPlatPreliminaryDate')?.disabled"></common-date-picker>
  </div>
  <div class="cell large-3 medium-3 small-6 bold text-align-right padding-right">
    As Drilled Plat Final Date:
    @if (fieldHasNotes('review|asDrilledPlatFinalDate') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'review|asDrilledPlatFinalDate'" [notes]="getFilteredNotes('review|asDrilledPlatFinalDate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6 text-align-left">
    <common-date-picker [id]="'platFinalDate'" [initialDate]="platFinalDate" (dateUpdated)="onDateUpdated($event, 'asDrilledPlatFinalDate')" [disabled]="form?.get('asDrilledPlatFinalDate')?.disabled"></common-date-picker>
  </div>
  <div class="cell large-3 medium-3 small-6 bold text-align-right padding-right">
    Borehole Deviation Survey Date:
    @if (fieldHasNotes('review|boreholeDeviationSurveyDate') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'review|boreholeDeviationSurveyDate'" [notes]="getFilteredNotes('review|boreholeDeviationSurveyDate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6 text-align-left">
    <common-date-picker [id]="'boreholeDeviationSurveyDate'" [initialDate]="boreholeDeviationSurveyDate" (dateUpdated)="onDateUpdated($event, 'boreholeDeviationSurveyDate')" [disabled]="form?.get('boreholeDeviationSurveyDate')?.disabled"></common-date-picker>
  </div>
  <div class="cell large-3 medium-3 small-6 bold text-align-right padding-right">
    Revised Unit Date:
    @if (fieldHasNotes('review|revisedUnitDate') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'review|revisedUnitDate'" [notes]="getFilteredNotes('review|revisedUnitDate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6 text-align-left">
    <common-date-picker [id]="'revisedUnitDate'" [initialDate]="revisedUnitDate" (dateUpdated)="onDateUpdated($event, 'revisedUnitDate')" [disabled]="form?.get('revisedUnitDate')?.disabled"></common-date-picker>
  </div>
  <div class="cell large-3 medium-3 small-6 bold text-align-right padding-right">
    As Drilled Fee Date:
    @if (fieldHasNotes('review|asDrilledFeeDate') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'review|asDrilledFeeDate'" [notes]="getFilteredNotes('review|asDrilledFeeDate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6 text-align-left">
    <common-date-picker [id]="'asDrilledFeeDate'" [initialDate]="asDrilledFeeDate" (dateUpdated)="onDateUpdated($event, 'asDrilledFeeDate')" [disabled]="form?.get('asDrilledFeeDate')?.disabled"></common-date-picker>
  </div>
  <div class="cell large-3 medium-3 small-6 bold text-align-right padding-right">
    Revised Unit Fee Date:
    @if (fieldHasNotes('review|revisedUnitFeeDate') || reviewStates?.includes(applicationState)) {
      <span class="padding-left">
        <view-notes [fieldName]="'review|revisedUnitFeeDate'" [notes]="getFilteredNotes('review|revisedUnitFeeDate')" (notesRequested)="handleNoteRequested($event)"></view-notes>
      </span>
    }
  </div>
  <div class="cell large-2 medium-2 small-6 text-align-left">
    <common-date-picker [id]="'revisedUnitFeeDate'" [initialDate]="revisedUnitFeeDate" (dateUpdated)="onDateUpdated($event, 'revisedUnitFeeDate')" [disabled]="form?.get('revisedUnitFeeDate')?.disabled"></common-date-picker>
  </div>
</div>